import { render, staticRenderFns } from "./QuotationOrderProofing.vue?vue&type=template&id=5b24e0e5"
import script from "./QuotationOrderProofing.vue?vue&type=script&lang=js"
export * from "./QuotationOrderProofing.vue?vue&type=script&lang=js"
import style0 from "./QuotationOrderProofing.vue?vue&type=style&index=0&id=5b24e0e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports